import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { UiService } from 'src/app/services/ui.service';
import { WbDialogService } from 'src/app/services/wb-dialog.service';
import { PencilButtonComponent } from 'src/app/standalones/components/pencil-button/pencil-button.component';
import {
  IconTypes,
  PencilIconComponent,
} from 'src/app/standalones/components/pencil-icon/pencil-icon.component';
import { CustomerSupportService } from 'src/app/services/customer-support.service';

@Component({
  selector: 'app-switch-call-to-this-device',
  templateUrl: './switch-call-to-this-device.component.html',
  styleUrls: ['./switch-call-to-this-device.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    PencilButtonComponent,
    PencilIconComponent,
    MatDialogModule,
    TranslateModule,
  ],
})
export class SwitchCallToThisDeviceComponent {
  @Output() joinCallInCurrentDevice = new EventEmitter<void>();
  @Output() requestCloseFromParentContainer = new EventEmitter<void>();

  IconTypes = IconTypes;

  constructor(
    protected uiService: UiService,
    private dialogRef: MatDialogRef<SwitchCallToThisDeviceComponent | undefined>,
    private customerSupportService: CustomerSupportService,
    wbDialogService: WbDialogService,
  ) {
    if (dialogRef._containerInstance) {
      // as the component maybe used as tooltip not just mat dialog
      wbDialogService.pushNewDialogRef<SwitchCallToThisDeviceComponent>(
        dialogRef as MatDialogRef<SwitchCallToThisDeviceComponent>,
      );
    }
  }

  onClose() {
    if (this.uiService.isMobile.value) {
      this.dialogRef?.close();
    } else {
      this.requestCloseFromParentContainer.emit();
    }
  }

  onJoinCall() {
    if (this.uiService.isMobile.value) {
      this.dialogRef?.close({ isJoinCall: true });
    } else {
      this.joinCallInCurrentDevice.emit();
    }
  }

  onOpenLink(link: string) {
    this.customerSupportService.openLink(link);
  }
}
